import React, { useState, useContext } from 'react';
import titlesData from '../../titles.json';
import {API_URL}  from '../../Constant';
import { MyContextProvider } from '../../App';
import messages from '../../assets/Messages.json';
import { ToastContainer, toast } from "react-toastify";
import { GlobalLoading, showLoading } from "react-global-loading";

function Index() {

    const [file, setFile] = useState(null);
    const [error, setError] = useState('');
    const [successMessage, setSuccessMessage] = useState('');


    


    const handleFileChange = (e) => {
        const selectedFile = e.target.files[0];
        setError('');
        setSuccessMessage('');
        

        if (selectedFile) {
          
            if (selectedFile.size > 40 * 1024 * 1024) {
               
                toast.error(messages.SIZE_40_MB, messages.COLOR_RED);
                setFile(null);
                return;
            }

           
            const fileNameParts = selectedFile.name.split('.');
            const fileExtension = fileNameParts[fileNameParts.length - 1].toLowerCase();
            
            if (fileExtension !== 'zip') {
               
                toast.error(messages.VALID_ZIP, messages.COLOR_RED);
                setFile(null);
                return;
            }

            setFile(selectedFile);
        }
    };

    const token = useContext(MyContextProvider).token;

    

    const handleUpload = () => {
        if (file) {
            showLoading(true)
            const formData = new FormData();
            formData.append('file', file);

            fetch(`${API_URL}api/price/uploadZipData`, {
                method: 'POST',
                body: formData,
                headers: {
                    'Authorization': `Bearer ${token}`,
                },
            })
            .then(response => response.json())
            .then(data => {
                
                console.log('Upload successful:', data);
                const fileInput = document.getElementById('fileInput');
                if (fileInput) {
                    fileInput.value = '';
                }

                setFile(null);
              
                toast.success(messages.FILE_UPLOADED, messages.COLOR_RED);

                formData.append('file','');
                showLoading(false)

            })
            .catch(error => {
               
                console.error('Error uploading file:', error);
                showLoading(false)
            });
        } else {
            toast.error(messages.SELECT_FILE, messages.COLOR_RED);
        }
    };


    const storedLanguage = localStorage.getItem('language');

    return (
        <>
            {/* Page Content Open   */}
            <ToastContainer />
            <GlobalLoading />
            <div className="container-fluid py-3 px-3">
                <div className="card mb-3">
                    <div className="card-body">
                        <h4 className="page_heading">Upload Data</h4>
                        
                        <div className="row align-items-center">            
                            <div className="col-xl-4 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                                <label>Upload a file</label>
                                <input type="file" className="form-control" onChange={handleFileChange}  id="fileInput"/>
                               
                            </div>
                            <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                                <label className="w-100">&nbsp;</label>
                                <button type="button" className="btn btn_orange" onClick={handleUpload} >Submit</button>
                            </div>
                            {error && <p className="text-danger">{error}</p>}
                        </div> 
                    </div>
                </div>
            </div>

        </>
    )
}

export default Index